import React, { useState } from 'react';
import { Search, ExternalLink } from 'lucide-react';
import SEO from '../../../common/SEO';


const ConferencePapers = () => {
  const [searchTerm] = useState('');
  const [, setLoadingLinks] = useState(new Set());



  // Papers data with the links you provided
  const papers = [
    {
      id: 1,
      title: "A Next Gen Encryption and Decryption Analysis based on Golay Codes",
      url: "https://journalspub.com/publication/ijaic/article=15982/",
      // category: "Encryption"
    },
    {
      id: 2,
      title: "FPGA Improved I2C Protocol for Multiple Slave Device Using VHDL",
      url: "https://journalspub.com/publication/ijmdic/article=15988/",
      // category: "Medical"
    },
    {
      id: 3,
      title: "Data Mining for E-Commerce and Social Media: Insights and Future Research Directions",
      url: "https://journals.stmjournals.com/?p=203967",
      // category: "Engineering"
    },
    {
      id: 4,
      title: "A Review of Machine Learning Applications in Web Data Mining",
      url: "https://journals.stmjournals.com/ijdss/article=2025/view=203328/",
      // category: "Computer Science"
    },
    {
      id: 5,
      title: "Vocational Education in Higher Secondary Schools: A Review of Factors Influencing Student Interest and Attitudes",
      url: "https://320b144e.streaklinks.com/CY7QubLHh-ANmCZwMAS83Ocl/https%3A%2F%2Fjournals.stmjournals.com%2Fijes%2Farticle%3D2025%2Fview%3D208148%2F",
      // category: "Industrial"
    },
    {
      id: 6,
      title: "Radiopharmaceuticals use as a nuclear medicine for a Treatment of Disease",
      url: "https://journals.stmjournals.com/jonet/article=2025/view=202621/",
      // category: "Networking"
    },
    {
      id: 7,
      title: "Grid Connected Renewable Energy System",
      url: "https://journalspub.com/publication/uncategorized/article=16079/",
      // category: "Research"
    },
    {
      id: 8,
      title: "A Review on Energy Storage System Enhancing the Stability of Micro grids",
      url: "https://journals.stmjournals.com/?p=206467",
      // category: "Engineering"
    },
    {
      id: 9,
      title: "Optimizing Power Output in Solar Chimney Power Plants: Influence of Collector Area and Chimney Height",
      url: "https://journalspub.com/publication/ijpecc/article=16083/",
      // category: "Electronics"
    },
    {
      id: 10,
      title: "Improvement in Output Power by Designing Adaptive Reference Control for Boost Converter in Solar System",
      url: "https://journalspub.com/publication/ijpecc/article=16086/",
      // category: "Electronics"
    },
    {
      id: 11,
      title: "AI-Driven Hybrid Neural Network Architecture for Medical Image Segmentation: A Novel Approach for Early Disease Detection",
      url: "https://journalspub.com/publication/ijmet/article=16075/",
      // category: "Mechanical"
    },
    {
      id: 12,
      title: "AI-Driven Handwriting Identification and Verification Using Textural Features",
      url: "https://journals.stmjournals.com/ijea/article=2025/view=206661/",
      // category: "Engineering"
    },
    {
      id: 13,
      title: "Optimization of Solar Drying Parameters for Turmeric and Papaya Leaves: Effects on Nutritional and Bioactive Compound Retention",
      url: "https://journals.stmjournals.com/ijepms/article=2025/view=206902/",
      // category: "Management"
    },
    {
      id: 14,
      title: "Advancements and Emerging Trends in Thermal Energy Storage Technologies for Sustainable Energy Systems",
      url: "https://journals.stmjournals.com/ijemad/article=2025/view=206478/",
      // category: "Management"
    },
    {
      id: 15,
      title: "Image Enhancement Techniques for Digital Images",
      url: "https://journals.stmjournals.com/?p=206580",
      // category: "Research"
    },
    {
      id: 16,
      title: "A Review Natural Ventilation by Using Solar Chimney",
      url: "https://journals.stmjournals.com/ijepms/article=2025/view=206894/",
      // category: "Management"
    },
    {
      id: 17,
      title: "A Study on Security Requirements of IOT",
      url: "https://journals.stmjournals.com/?p=206641",
      // category: "Research"
    },
    {
      id: 18,
      title: "A Review on Cognitive Radio Sensor Networks for Internet of Things",
      url: "https://journalspub.com/publication/ijbcc/article=16093/",
      // category: "Blockchain"
    },
    {
      id: 19,
      title: "Wireless Sensor Networks and Its Clustering Algorithm",
      url: "https://journalspub.com/publication/ijmet/article=16069/",
      // category: "Mechanical"
    },
    {
      id: 20,
      title: "Automated Suspicious Activity Detection in Video Surveillance  Using Deep Learning: A Review",
      url: "https://journals.stmjournals.com/ijoir/article=2025/view=206771/",
      // category: "Operations"
    },
    {
      id: 21,
      title: "Performance Assessment of External Source-Driven Binary Vapor Cycles with Ammonia-Water and Trans-Critical CO2 The Impact of Reheating and Pressure Variations",
      url: "https://journals.stmjournals.com/jotea/article=2025/view=198368/",
      // category: "Technology"
    },
    {
      id: 22,
      title: "Advancements and Challenges in Solar Water Heating Systems: A Sustainable Solution for Energy Conservation and Environmental Impact Reduction",
      url: "https://journals.stmjournals.com/joaest/article=2025/view=209436/",
      // category: "Applied Science"
    },
    {
      id: 23,
      title: "Implementing Machine Learning in Data Classification",
      url: "https://journals.stmjournals.com/article/article=2025/view=210737/",
      // category: "Research"
    },
    {
      id: 24,
      title: "Prediction of Perineal Trauma During Childbirth by Assessment of Striae Gravidarum Score",
      url: "https://journalspub.com/publication/ijonn/article=16481/",
      // category: "Neural Networks"
    },
    {
      id: 25,
      title: "Exploring the Luminescent Behavior of Dysprosium-Doped Halo-sulphate Compounds",
      url: "https://journals.stmjournals.com/jomme/article=2025/view=209561/",
      // category: "Materials"
    },
    {
      id: 26,
      title: "A Comparative Study of Solar, Wind, and Biomass Energy for Decentralized Power Generation.",
      url: "https://journals.stmjournals.com/ijrec/article=2025/view=209928/",
      // category: "Energy"
    },
    {
      id: 27,
      title: "Development and Performance Analysis of Pyramid Shaped Novel Solar Water Heater",
      url: "https://journals.stmjournals.com/ijrec/article=2025/view=209928/",
      // category: "Network Science"
    },
    {
      id: 28,
      title: "A Survey on Intrusion Detection in Wireless Sensor Network",
      url: "https://journals.stmjournals.com/jons/article=2025/view=207946/",
      // category: "Research"
    },
    {
      id: 29,
      title: "Leveraging Management Frameworks and Academia-Industry Collaboration for Enhanced Efficiency and Productivity in Startups",
      url: "https://b04589c0.streaklinks.com/CdqfISmuLoXYtxRk1g0Y6E7P/https%3A%2F%2Fjournals.stmjournals.com%2F%3Fp%3D213312",
      // category: "Engineering"
    },
    {
      id: 30,
      title: "The Impact of High-Performance Computing on FEA and CFD Simulations",
      url: "https://journals.stmjournals.com/article/article=2025/view=210767/",
      // category: "Conference"
    },
    {
      id: 31,
      title: "Development of Hybrid Solar Thermal System with Dish Concentrators and Fresnel Lens for Hot Water Generation.",
      url: "https://www.ijeit.com/Special Issue/Volume 5/Issue 1/IJEIT_ICREACT19.pdf",
      // category: "Technology"
    },
    {
      id: 32,
      title: "Advances in Multiclass Oral Cancer Detection Using Spectroscopic and AI Techniques",
      url: "https://journals.stmjournals.com/rrjod/article=2025/view=209549/",
      // category: "Operations"
    },
    {
      id: 33,
      title: "Advanced Modeling Approaches for Assessing Human Health Impacts of Environmental Changes",
      url: "https://journalspub.com/publication/ijec/article=16432/",
      // category: "Electronics"
    },
    {
      id: 34,
      title: "Fault Detection in Solar PV Systems Integrated with the Power Grid: Evaluating Logistic Regression through Confusion Matrix Analysis",
      url: "https://journals.stmjournals.com/jopeps/article=2025/view=210743/",
      // category: "Environmental"
    },
    {
      id: 35,
      title: "Advancing Sustainability: A Comprehensive Review of Environmental, Social, and Governance (ESG) Practices",
      url: "https://journals.stmjournals.com/article/article=2025/view=213484/",
      // category: "Research"
    },
    {
      id: 36,
      title: "Exploring the Evolution of Environmental, Social, and Governance (ESG) Practices: A Comprehensive Review",
      url: "https://lawjournals.celnet.in/index.php/jcgibl/article/view/1875",
      // category: "Business Law"
    },
    {
      id: 37,
      title: "Comparative Analysis of Sustainable Materials in Road Construction: A Review",
      url: "https://journals.stmjournals.com/jocetm/article=2025/view=214526/",
      // category: "Technology"
    },
    {
      id: 38,
      title: "Comparative Review of Innovations in Self-Compacting Concrete (SCC) Technologies",
      url: "https://journals.stmjournals.com/article/article=2025/view=215900/",
      // category: "Research"
    },
    {
      id: 39,
      title: "Review of Research on Pozzolanic Materials for Cement Blending and Concrete Applications",
      url: "https://journals.stmjournals.com/article/article=2025/view=214528/",
      // category: "Management"
    },
    {
      id: 40,
      title: "Innovations and Comparative Analyses in Foam Concrete: A Review of Emerging Techniques and Materials",
      url: "https://journals.stmjournals.com/article/article=2025/view=215783/",
      // category: "Research"
    },
    {
      id: 41,
      title: "Human Resource Innovations in Recent Trends and Best Practice for Workplace",
      url: "https://mbajournals.in/index.php/JoPMRS/article/view/1328",
      // category: "Research"
    },
    {
      id: 42,
      title: "Advancements in Thermal Performance of Solar Flat Plate Collectors: A Comprehensive Review",
      url: "https://journals.stmjournals.com/article/article=2025/view=213492/",
      // category: "Research"
    },
    {
      id: 43,
      title: "Transformative Impact of Artificial Intelligence on Telecommunications: Network Optimization, Predictive Maintenance, and Personalized User Experience",
      url: "https://journals.stmjournals.com/jotssn/article=2025/view=197477/",
      // category: "Research"
    },
    {
      id: 44,
      title: "Printed Electronics: Materials, Manufacturing Methods, and Applications -A Critical Review",
      url: "https://journals.stmjournals.com/article/article=2025/view=216081/",
      // category: "Research"
    },
    {
      id: 45,
      title: "Improvement in Output Power by Designing Adaptive Reference Control for Boost Converter in Solar System",
      url: "https://journalspub.com/publication/ijpecc/article=16086/",
      // category: "Research"
    },
    {
      id: 46,
      title: "Enhancing Production Line Efficiency: Simulating and Optimizing Single and Parallel Line Processes",
      url: "https://journals.stmjournals.com/joprm/article=2025/view=213894/",
      // category: "Research"
    },
    {
      id: 47,
      title: "Breakthroughs in Solar and Wind Energy Technologies",
      url: "https://journals.stmjournals.com/article/article=2025/view=216103/",
      // category: "Research"
    },
    {
      id: 48,
      title: "Integration of Wind and Solar Energy with Fuzzy Logic Control MPPT for Grid-Connected Hybrid Renewable Power Generation",
      url: "https://journals.stmjournals.com/ijepms/article=2025/view=234677/",
      // category: "Research"
    }
  ];

  // Filter papers based on search term
  const filteredPapers = papers.filter(paper => 
    paper.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    paper.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleLinkClick = (paperId, url) => {
    // Add loading state
    setLoadingLinks(prev => new Set(prev).add(paperId));
    
    // Open link immediately (don't wait for the page to load)
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    
    // Remove loading state after a short delay
    setTimeout(() => {
      setLoadingLinks(prev => {
        const updated = new Set(prev);
        updated.delete(paperId);
        return updated;
      });
    }, 1500);
    
    // Fallback if popup blocker prevents opening
    if (!newWindow) {
      window.location.href = url;
    }
  };

  const getCategoryColor = (category) => {
    const colors = {
      'Engineering': 'bg-blue-100 text-blue-800',
      'Electronics': 'bg-yellow-100 text-yellow-800',
      'Medical': 'bg-green-100 text-green-800',
      'Research': 'bg-purple-100 text-purple-800',
      'Management': 'bg-indigo-100 text-indigo-800',
      'Technology': 'bg-red-100 text-red-800',
      'Networking': 'bg-cyan-100 text-cyan-800',
      'Blockchain': 'bg-orange-100 text-orange-800',
      'Energy': 'bg-emerald-100 text-emerald-800',
      'default': 'bg-gray-100 text-gray-800'
    };
    return colors[category] || colors.default;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-4 sm:py-8 px-3 sm:px-6">
      <SEO 
        title="IEEE & SCI Research Paper Design and Publication Bhopal"
        description="Browse Research Paper design and publication, IEEE paper writing, SCI paper writing bhopal, Scopus paper writing bhopal, and Conference paper writing publication."
        keywords={[
          "IEEE paper writing",
          "SCI paper writing bhopal",
          "Scopus paper writing bhopal",
          "Research Paper design and publication",
          "Research paper writing and publication",
          "Paper Writing Bhopal",
          "Conference paper writing publication"
        ]}
        canonicalPath="/conference-papers"
      />

      
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-6 sm:mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl mb-4 shadow-lg">
            <ExternalLink className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-indigo-800 bg-clip-text text-transparent mb-3">
            Conference Publications
          </h1>
          <p className="text-gray-600 text-sm sm:text-base lg:text-lg max-w-2xl mx-auto">
            Explore our comprehensive collection of published research papers and conference proceedings
          </p>
        </div>

        {/* Search Bar */}
        

        {/* Papers List */}
        <div className="bg-white/70 backdrop-blur-sm rounded-2xl shadow-xl border border-white/50 overflow-hidden">
          {filteredPapers.length > 0 ? (
            <div className="divide-y divide-gray-100/80">
              {filteredPapers.map((paper, index) => (
                <div key={paper.id} className="group p-4 sm:p-6 hover:bg-blue-50/50 transition-all duration-300">
                  <div className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-4">
                    {/* Paper Number */}
                    <div className="flex-shrink-0">
                      <span className="inline-flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-blue-500 to-indigo-500 text-white text-sm sm:text-base font-bold rounded-full shadow-md">
                        {index + 1}
                      </span>
                    </div>
                    
                    {/* Paper Content */}
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                        <div className="flex-1">
                          <h3 className="text-base sm:text-lg lg:text-xl font-semibold text-gray-900 leading-relaxed mb-2 group-hover:text-blue-700 transition-colors duration-200 cursor-pointer"
                          onClick={() => handleLinkClick(paper.id, paper.url)}>
                            {paper.title}
                            
                          </h3>
                          <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${getCategoryColor(paper.category)}`}>
                            {paper.category}
                          </span>
                        </div>
                        
                        {/* View Button
                        <div className="flex-shrink-0 mt-2 lg:mt-0">
                          <button
                            onClick={() => handleLinkClick(paper.id, paper.url)}
                            disabled={loadingLinks.has(paper.id)}
                            className="inline-flex items-center gap-2 px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 disabled:from-gray-400 disabled:to-gray-500 text-white font-semibold text-sm sm:text-base rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 disabled:cursor-not-allowed disabled:transform-none"
                          >
                            {loadingLinks.has(paper.id) ? (
                              <>
                                <Clock className="w-4 h-4 animate-spin" />
                                <span className="hidden sm:inline">Opening...</span>
                                <span className="sm:hidden">...</span>
                              </>
                            ) : (
                              <>
                                <ExternalLink className="w-4 h-4" />
                                <span className="hidden sm:inline">View Paper</span>
                                <span className="sm:hidden">View</span>
                              </>
                            )}
                          </button>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-16 sm:py-20">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Search className="w-8 h-8 text-gray-400" />
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">No papers found</h3>
              <p className="text-gray-600 text-sm sm:text-base max-w-md mx-auto">
                Try adjusting your search terms or browse all available papers
              </p>
            </div>
          )}
        </div>

        {/* Footer Stats */}
      
      </div>
    </div>
  );
};

export default ConferencePapers;